/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 * @author Nikolay Sviridov
 * @version 1.35.0
 * @since 1.35.0
 */

import type { FC } from 'react';

import { EllipsisText, Typography } from '@nexign/scc-ui-kit';

import { RoamingOptionContainerTextStyled } from '../styled/RoamingOptionsStyled';

interface IServiceDescriptionProps {
	title?: string;
	shortDescription?: string;
}

export const RoamingOptionDescription: FC<IServiceDescriptionProps> = ({ title, shortDescription }) => {
	return (
		<>
			<RoamingOptionContainerTextStyled>
				<EllipsisText
					lines={2}
					tooltipContentMaxWidth={400}
					tooltipPlacement='bottom'
					tooltipTitle={title}
				>
					<Typography
						component='span'
						variant='h3'
					>
						{title}
					</Typography>
				</EllipsisText>
			</RoamingOptionContainerTextStyled>

			<RoamingOptionContainerTextStyled
				marginBottom={24}
				minHeight={72}
			>
				<EllipsisText
					lines={3}
					tooltipContentMaxHeight={200}
					tooltipContentMaxWidth={400}
					tooltipContentOverflow='auto'
					tooltipPlacement='bottom'
					tooltipTitle={shortDescription}
				>
					<Typography component='span'>{shortDescription}</Typography>
				</EllipsisText>
			</RoamingOptionContainerTextStyled>
		</>
	);
};
